import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { Utils } from '@core/helper';
import { VitalModel } from '@core/models/models';
import { CommonHelper } from '@core/services/common';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'caremoni-vital',
  templateUrl: './vital.component.html',
  styleUrl: './vital.component.scss'
})
export class VitalComponent implements OnInit {
  @Input() data: VitalModel = new VitalModel();
  @Input() config: any = {};
  spo2: string = '';
  bp: string = '';
  temperature: any = '';
  pulse: any = '';
  attention_flg: boolean = false;
  cssStyle: any = {};
  isWarning: boolean = false;
  constructor(@Optional() @Inject('showcaseData') injectedData: VitalModel) { 
    this.data = injectedData ?? this.data;
  }

  ngOnInit(): void {
    if (this.data && Array.isArray(this.data)) {
      let arrayData: any[] = CommonHelper.getArrayData(cloneDeep(this.data)) || [];
      if (arrayData.length > 0) {
        // 1 tiếng tính bằng mili giây
        const oneHour = 60 * 60 * 1000;
        // Lấy thời gian hiện tại
        const currentTime = new Date().getTime();
        const uniqueDates = new Set(
          arrayData
            ?.map(dt => dt?.date ? new Date(dt.date).toLocaleDateString() : null)
            ?.filter(Boolean)
        );
        // Kiểm tra nếu arrayData có từ 2 phần tử trở lên và các phần tử có date khác nhau
        if (arrayData?.length > 1) {
          this.isWarning = false; // Mặc định tắt cảnh báo

          arrayData?.forEach(dt => {
            // Bỏ qua nếu dt.date null hoặc undefined
            if (!dt.date) return;
            // Lấy timestamp từ `date`
            const dataTime = dt.date.getTime();

            // Nếu chênh lệch giữa `dataTime` và `currentTime` < 1 tiếng thì bật cảnh báo
            if (Math.abs(currentTime - dataTime) <= oneHour && uniqueDates?.size <= 1) {
              this.isWarning = true;
            }
          });
        }
        // lấy data của phần tử đầu tiên
        this.mapData(arrayData[0]);
      }
    } else {
      this.mapData(this.data);
    }
    this.cssStyle = {
      ...this.cssStyle,
      'color': this.isWarning ? '#000000' : 'inherit'
    };
  }

  mapData(data: any) {
    if (!data) return;
    this.attention_flg = data?.attention_flg || false;
    this.pulse = data?.pulse ? data?.pulse : '';

    if (!data?.temperature || isNaN(parseFloat(data.temperature)) ) {
      this.temperature = '';
    }
    else{
      this.temperature = parseFloat(data.temperature).toFixed(1);
    }
    this.spo2 = data.spo2 ? data.spo2 + '%' : '';
    this.bp = this.formatBpValue(data?.bp_top, data?.bp_bottom);
  }

  formatBpValue(top: any, bottom: any){
    if (Utils.isNullOrEmpty(top) && Utils.isNullOrEmpty(bottom)) {
      return '';
    }
    top = Utils.isValidNumber(top) ? top : '';
    bottom = Utils.isValidNumber(bottom) ? bottom : '';
    return `${top}/${bottom}`;
  }
}